import { IsNotEmpty, IsOptional } from "class-validator";

export class ConfigurationDto {
  @IsNotEmpty()
  key: string;

  @IsOptional()
  value: string;
}
